export const VERIFICATION_LIST = ['facebook', 'google', 'email']
export const USER_STATUS_MEMBER_DELETED = 3
